import React, { CSSProperties, ReactNode, useEffect, useRef } from 'react';
import { H5, Paragraph } from '../heading';
import * as styles from './index.module.less';
import { PublicArrowUpOutlined } from 'notta-web-icon';

interface IProps {
  title: ReactNode | string;
  content: ReactNode | string;
  defaultOpen?: boolean;
  contentClass?: string;
  titleClass?: string;
  style?: CSSProperties;
}

const Collapse = ({ title, content, defaultOpen = false, contentClass = '', titleClass = '', style }: IProps) => {
  const isTitleIsString = typeof title === 'string';
  const isContentIsString = typeof content === 'string';
  const collapseRef = useRef<any>(null);
  const arrowRef = useRef<any>(null);

  const handleQuestionClick = () => {
    arrowRef.current.classList.toggle(styles.collapse_arrow_active);
    const [, contentDom] = Array.from(collapseRef.current.children);
    if (window.getComputedStyle(contentDom).maxHeight === '0px') {
      contentDom.style.maxHeight = contentDom.scrollHeight + 'px';
    } else {
      contentDom.style.maxHeight = '0px';
    }
  };

  useEffect(() => {
    if (defaultOpen) {
      handleQuestionClick();
    }
  }, [defaultOpen]);

  return (
    <div className={styles.collapse_container} ref={collapseRef} style={style}>
      <div className={`${styles.title} ${titleClass}`} onClick={handleQuestionClick}>
        {isTitleIsString ? <H5 style={{ marginBottom: '0' }}>{title}</H5> : title}
        <div className={styles.collapse_arrow} ref={arrowRef}>
          <PublicArrowUpOutlined />
        </div>
      </div>
      <div className={`${styles.content} ${contentClass}`}>
        {isContentIsString ? <Paragraph>{content}</Paragraph> : content}
      </div>
    </div>
  );
};
export default Collapse;
